import React, {forwardRef} from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from './Typography.jsx';
import styles from '../styles/styles';
import useUniqueId from '../hooks/useUniqueId.js';
import {DatePicker as MaterialDatePicker} from '@material-ui/pickers';
const {makeStyles} = styles;

const DatePicker = (props, ref) => {
  const classes = useStyles();
  const uniqueId = useUniqueId();
  const {label, name, format, disabled, valueFormat, value, error, ...rest} = props;
  const stringValue = React.useMemo(() => {
    if (!value) return null;
    return moment(value, valueFormat);
  }, [value, valueFormat]);
  const handleChange = (dateMoment) => {
    if (!format) props.onChange(dateMoment.toDate());
    else props.onChange(dateMoment && dateMoment.format(format));
  };
  return (
    <div className={classes.dateWrapper}>
      <MaterialDatePicker
        KeyboardButtonProps={{'aria-label': 'change date'}}
        className={ classNames(classes.date, !!error && classes.errorInput) }
        autoOk
        inputVariant={ 'outlined' }
        {...rest}
        disabled={disabled}
        id={uniqueId}
        format={ format || 'MM/DD/yyyy' }
        onChange={ handleChange }
        name={ name }
        label={ label }
        value={ stringValue }
        ref={ref}/>
      {
        !!error && (
          <Typography
            variant={'body1'}
            role="alert"
            aria-label={error}
            className={classes.errorText}
          >
            {error}
          </Typography>
        )
      }
    </div>
  );
};

DatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.node,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
};


const useStyles = makeStyles((theme) => ({
  dateWrapper: {
    height: '100%'
  },
  selectCard: {
    flex: 1,
    width: '100%',
    height: 56,
    backgroundColor: 'white',
    borderRadius: 4,
    boxShadow: `rgba(0,0,0,.07) 0px 0px 12px`,
  },
  dateContainer: {
    // paddingTop: theme.spacing(),
    position: 'relative',
    height: 64 - theme.spacing(2),
  },
  date: {
    width: '100%',
    height: '100%'
  },
  errorInput: {
    '& label': {
      color: '#CF0000',
    },
    '& div.MuiInputBase-root fieldset': {
      borderColor: '#CF0000',
    },
  },
  errorText: {
    color: '#CF0000',
    paddingLeft: theme.spacing(2),
    fontSize: '0.75rem',
    marginTop: 3,
    fontWeight: 400,
    lineHeight: '1.66',
    letterSpacing: '0.03333em',
  },
}));

export default forwardRef(DatePicker);
